// Builds the standardized Passport result for the Experience Engine report.
// Only production-compatible activities are reported as created. Rewards,
// achievements, and progress remain owned by the redemption Cloud Function.

export const buildPassportReport = ({ passportResults } = {}) => {
  const stops = passportResults?.stops || [];

  return {
    success: true,
    created: {
      passportStops: stops.length,
    },
    summary: `${stops.length} Passport Stops`,
  };
};
